module.exports = __webpack_public_path__ + "img/ueasy-logo.45320009.png";